var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowtyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 415.7",
    style: {
      enableBackground: "new 0 0 1200 415.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:#FFFFFF;}\n\t.st1{clip-path:url(#SVGID_2_);fill:#5BC096;}\n\t.st2{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 23,
    y: 40,
    width: 1200,
    height: 370.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.9,128.9c8-27.5,26.1-43.2,54.3-47.1h74.9l-11.7,48.6h-51.8c-3.3,0-6.5,1.2-9.4,3.5 c-2.8,2.3-4.6,5.3-5.3,8.9l-9,32.9h36.9l-11.4,48.6H143l-20.6,83H68.3L112.9,128.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.5,81.8h55.1l-42.8,167.7c-0.3,2.8,0.3,5.3,2,7.5c1.8,2.2,4.2,3.3,7.2,3.3h30.1l-11.9,47h-37.6 c-15.3,0-27.4-5.8-36.4-17.4c-9-11.6-12.1-25.1-9.2-40.4L276.5,81.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.9,293.7c-8.4-6.3-14.6-15-18.9-25.9c-9.5-23.7-7.5-50.3,6-79.7c18-32.7,47.2-49.8,87.6-51.3 c9.8-0.6,19.8-0.4,29.9,0.3c16.5,1.4,29,5.5,37.4,12.1c8.5,6.6,14.9,15.4,19.2,26.3c9.5,23.8,7.5,50.4-6,79.7 c-17.9,32.9-47.7,50.1-89.2,51.8c-8.5,0.6-18,0.4-28.7-0.5C403.7,304.3,391.3,300,382.9,293.7 M494.5,225.8 c3.5-12.7,3.6-22.4,0.3-29.1c-3.2-6.7-11.2-10.6-23.9-11.7c-16.5-1.2-30.1,1.6-40.8,8.5c-8.4,6.5-13.9,14.4-16.5,23.9 c-7.7,25.3,0.2,38.9,23.6,40.8c19.2,0.4,32.7-2.4,40.8-8.5C486.3,243.4,491.8,235.4,494.5,225.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M570.4,249.7l27.4-112.3h54.8l-27.4,112.3c-0.3,2.8,0.3,5.3,2,7.5c1.7,2.2,4.1,3.3,7.2,3.3h23.7 c0.1-3.7,0.6-7.3,1.5-10.9L687,137.4h54.8l-27.4,112.3c-0.4,2.8,0.2,5.3,2,7.5c1.7,2.2,4.1,3.3,7.2,3.3H747L776,137.4h55.8 l-41.1,169.8H741v0.2h-37.4c-21.4,0-35.9-11-43.6-32.9l-7.7,32.7h-18.7v0.2h-19c-15,0-27-5.8-35.8-17.4 C569.8,278.5,567,265.1,570.4,249.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M832.8,249.6l41.3-167.7h54.1c-9.1,35.8-13.9,54.2-14.2,55.5H954l-12,49.3h-39.8c-2.9,11.9-5.3,21.8-7.2,29.7 c-1.9,7.9-3.6,15-5.2,21.4c-1.6,6.4-2.5,10.4-2.8,11.9c-0.3,2.8,0.3,5.3,2,7.5c1.7,2.2,4,3.3,7,3.3h28.1l-11.4,47h-36.4 c-14.9,0-26.7-5.8-35.3-17.4C832.3,278.4,829.6,264.9,832.8,249.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M994.4,323.2h28.7c3,0,5.9-1.1,8.7-3.3c2.8-2.2,4.7-4.7,5.7-7.5l1.2-4.7h-39.3c-15,0-27-5.8-35.8-17.4 c-8.8-11.6-11.5-25.1-8-40.4l27.2-112.4h55l-27.2,112.4c-0.3,2.8,0.3,5.3,1.8,7.5c1.7,2.2,4.1,3.3,7.4,3.3h29.6l29.9-123.3h0.3 l0.2-0.5h55l-42.1,175.4c-4.2,15.4-13.6,28.8-28.1,40.4c-14.6,11.6-29.4,17.4-44.4,17.4h-37.6L994.4,323.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1179,286.9c0,16.6-13.4,30-30,30c-16.6,0-30-13.4-30-30c0-16.6,13.4-30,30-30 C1165.6,256.9,1179,270.3,1179,286.9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1135.8,329.9h-5.1v-3.7h14.9v3.7h-5.1v12.9h-4.7V329.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1162.3,342.8l0-8.8l-4.3,7.2h-2.1l-4.3-6.9v8.6h-4.3v-16.6h3.9l5.8,9.6l5.7-9.6h3.9l0,16.6H1162.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowtyLogo);
export default __webpack_public_path__ + "static/media/flowty_logo.cd0bca1db634b8b8d0936bf9130c5406.svg";
export { ForwardRef as ReactComponent };